import { render, staticRenderFns } from "./commonDialog.vue?vue&type=template&id=d615185e&scoped=true&"
import script from "./commonDialog.vue?vue&type=script&lang=js&"
export * from "./commonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d615185e",
  null
  
)

export default component.exports